(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    /* Slide open/close for the accordion primitive. The expanded state stays the
     native [open] attribute - this only animates the transition between states,
     so no-JS and reduced-motion users still get the native instant toggle. */
  (function () {
    if (window.__accordionSlideBound) {
      return;
    }
    window.__accordionSlideBound = true;

    var DURATION = 240;
    var EASING = "cubic-bezier(0.4, 0, 0.2, 1)";

    var prefersReducedMotion = function () {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    };

    var slide = function (details, expanding) {
      var content = details.querySelector(".accordion__content");

      if (!content || !details.animate || prefersReducedMotion()) {
        details.open = expanding;
        return;
      }

      var existing = details.__accordionAnimation;
      if (existing) {
        existing.cancel();
      }

      // The panel is only measurable while [open], so open first and let the
      // animation own the visible height for the closing case too.
      details.open = true;
      details.setAttribute("data-accordion-animating", "");

      // The panel's own padding is why this animates more than height. The content
      // box is border-box, so `height: 0` still renders its 28px of padding (4 top +
      // 24 bottom) and the box cannot go below that. Measured on the contact-page
      // FAQs: the panel snapped open 28px, held there ~65ms while the height
      // animation crossed the clamped stretch, and only then started moving - the
      // reported jumpiness, mirrored on close as a 28px snap shut at the end.
      // Animating the padding to 0 alongside the height gives the panel the whole
      // distance to travel, so it starts from nothing and lands exactly on its
      // resting height.
      //
      // component-accordion.css:44 also gives .accordion__content a 1.5rem bottom
      // margin - Madrid's generic spacing, outside the box height animates. Left
      // alone it held its full 15px through the whole slide and then vanished with
      // [open]: measured on the one-open handoff, the outgoing panel bottomed out at
      // 64px against a 49px closed row and snapped the last 15px in a single frame.
      // It collapses with everything else here.
      var styles = getComputedStyle(content);
      var padTop = styles.paddingTop;
      var padBottom = styles.paddingBottom;
      var marginBottom = styles.marginBottom;
      var height = content.getBoundingClientRect().height;

      var frames = expanding
        ? {
            height: ["0px", height + "px"],
            paddingTop: ["0px", padTop],
            paddingBottom: ["0px", padBottom],
            marginBottom: ["0px", marginBottom]
          }
        : {
            height: [height + "px", "0px"],
            paddingTop: [padTop, "0px"],
            paddingBottom: [padBottom, "0px"],
            marginBottom: [marginBottom, "0px"]
          };

      var animation = content.animate(frames, {
        duration: DURATION,
        easing: EASING
      });

      details.__accordionAnimation = animation;

      // Both handlers confirm they still own the element. cancel() dispatches
      // asynchronously, so on a fast second click the outgoing animation's handler
      // would otherwise fire after the incoming one has started and strip
      // data-accordion-animating from it - dropping the overflow clip mid-slide and
      // letting the panel spill past its box.
      animation.addEventListener("finish", function () {
        if (details.__accordionAnimation !== animation) {
          return;
        }
        details.__accordionAnimation = null;
        details.removeAttribute("data-accordion-animating");
        details.open = expanding;
      });

      animation.addEventListener("cancel", function () {
        if (details.__accordionAnimation !== animation) {
          return;
        }
        details.removeAttribute("data-accordion-animating");
      });
    };

    // Delegated at document level so the handler survives Section Rendering API
    // swaps and covers accordions rendered after load.
    document.addEventListener("click", function (event) {
      var summary = event.target.closest(".accordion--component > .accordion__trigger");

      if (!summary) {
        return;
      }

      var details = summary.parentElement;

      if (!details.querySelector(".accordion__content")) {
        return;
      }

      event.preventDefault();
      slide(details, !details.open);
    });

    // Exposed so group behaviours (one-open) close siblings through the same
    // animation path instead of flipping [open] straight to false.
    window.accordionSlide = slide;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets-sort"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("sort-menu")) {
    class SortMenu extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector("[data-sort-trigger]");
        this.popoverEl = this.querySelector("[data-sort-popover]");
        this.list = this.querySelector("[data-sort-list]");
        this.valueEl = this.querySelector("[data-sort-value]");
        this.drawer = document.getElementById(this.dataset.drawerId || "SortDrawer");
        this.mql = window.matchMedia("(min-width: 990px)");
        this.onDocClick = this.onDocClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        if (this.trigger) {
          this.trigger.addEventListener("click", () => this.onTriggerClick());
        }
        // Selecting an option re-sorts (facets.js listens on the form's `input`);
        // close the surface immediately and mirror the label optimistically.
        this.addEventListener("change", (e) => {
          if (e.target && e.target.name === "sort_by") this.onSelect(e.target);
        });
      }

      isDesktop() {
        return this.mql.matches;
      }

      onTriggerClick() {
        if (this.isDesktop()) {
          this.classList.contains("is-open") ? this.closePopover() : this.openPopover();
        } else {
          this.openDrawer();
        }
      }

      openPopover() {
        if (!this.popoverEl) return;
        this.classList.add("is-open");
        this.popoverEl.hidden = false;
        if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
        document.addEventListener("click", this.onDocClick, true);
        document.addEventListener("keydown", this.onKeydown, true);
      }

      closePopover(refocus) {
        if (!this.classList.contains("is-open")) return;
        this.classList.remove("is-open");
        if (this.popoverEl) this.popoverEl.hidden = true;
        if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
        document.removeEventListener("click", this.onDocClick, true);
        document.removeEventListener("keydown", this.onKeydown, true);
        if (refocus && this.trigger) this.trigger.focus();
      }

      openDrawer() {
        if (!this.drawer || !this.list) return;
        // Move the single sort_by group into the drawer body (no duplicate group).
        var body = this.drawer.querySelector(".drawer__body");
        if (body && this.list.parentElement !== body) body.appendChild(this.list);
        if (typeof this.drawer.open === "function") {
          this.drawer.open(this.trigger);
        }
        if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
        // Return the list to the popover when the drawer closes.
        var self = this;
        this.drawer.addEventListener(
          "transitionend",
          function returner() {
            if (!self.drawer.classList.contains("active")) {
              if (self.popoverEl && self.list && self.list.parentElement !== self.popoverEl) {
                self.popoverEl.appendChild(self.list);
              }
              if (self.trigger) self.trigger.setAttribute("aria-expanded", "false");
              self.drawer.removeEventListener("transitionend", returner);
            }
          }
        );
      }

      onSelect(input) {
        var labelEl = input
          .closest(".radio")
          .querySelector(".radio__label");
        if (this.valueEl && labelEl) this.valueEl.textContent = labelEl.textContent.trim();
        if (this.isDesktop()) {
          this.closePopover(false);
        } else if (this.drawer && typeof this.drawer.close === "function") {
          this.drawer.close();
        }
      }

      onDocClick(e) {
        if (!this.contains(e.target)) this.closePopover(false);
      }

      onKeydown(e) {
        if (e.key === "Escape") {
          e.preventDefault();
          this.closePopover(true);
        }
      }
    }
    customElements.define("sort-menu", SortMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-dropdown"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll("[data-input-dropdown]").forEach(function (root) {
    if (root.dataset.inputDropdownReady) return;
    root.dataset.inputDropdownReady = "true";

    var trigger = root.querySelector("[data-input-dropdown-trigger]");
    var menu = root.querySelector("[data-input-dropdown-menu]");
    var valueEl = root.querySelector("[data-input-dropdown-value]");
    var hidden = root.querySelector("[data-input-dropdown-input]");
    var placeholder = valueEl ? valueEl.textContent.trim() : "";
    var wasPlaceholder = valueEl && valueEl.classList.contains("input-dropdown__value--placeholder");
    var search = root.querySelector("[data-input-dropdown-search] input");
    var emptyRow = root.querySelector("[data-input-dropdown-empty]");
    if (!trigger || !menu) return;

    function items() {
      return Array.prototype.slice.call(root.querySelectorAll("[data-input-dropdown-item]"));
    }
    function visibleItems() {
      return items().filter(function (i) {
        return i.parentElement && !i.parentElement.hidden && i.offsetParent !== null;
      });
    }
    function isOpen() {
      return root.classList.contains("is-open");
    }

    function open() {
      if (trigger.disabled || isOpen()) return;
      root.classList.add("is-open");
      menu.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      document.addEventListener("click", onDocClick, true);
      document.addEventListener("keydown", onKeydown, true);
      if (search) {
        search.focus();
      } else {
        var current = root.querySelector(".input-dropdown__item.is-selected") || visibleItems()[0];
        if (current) current.focus();
      }
    }
    function close(refocus) {
      if (!isOpen()) return;
      root.classList.remove("is-open");
      menu.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", onDocClick, true);
      document.removeEventListener("keydown", onKeydown, true);
      if (refocus) trigger.focus();
    }

    function selectItem(item) {
      items().forEach(function (i) {
        i.classList.remove("is-selected");
        i.setAttribute("aria-selected", "false");
      });
      item.classList.add("is-selected");
      item.setAttribute("aria-selected", "true");
      var labelEl = item.querySelector(".input-dropdown__item-label");
      if (valueEl) {
        valueEl.textContent = labelEl ? labelEl.textContent.trim() : item.getAttribute("data-value");
        valueEl.classList.remove("input-dropdown__value--placeholder");
      }
      if (hidden) {
        hidden.value = item.getAttribute("data-value") || "";
        hidden.dispatchEvent(new Event("change", { bubbles: true }));
      }
      root.dispatchEvent(new CustomEvent("input-dropdown:change", {
        bubbles: true,
        detail: { value: item.getAttribute("data-value") }
      }));
      close(true);
    }

    function filter() {
      if (!search) return;
      var q = search.value.trim().toLowerCase();
      var shown = 0;
      items().forEach(function (i) {
        var t = (i.textContent || "").trim().toLowerCase();
        var match = t.indexOf(q) !== -1;
        if (i.parentElement) i.parentElement.hidden = !match;
        if (match) shown++;
      });
      if (emptyRow) emptyRow.hidden = shown !== 0;
    }

    function onDocClick(e) {
      if (!root.contains(e.target)) close(false);
    }
    function onKeydown(e) {
      var vis = visibleItems();
      var idx = vis.indexOf(document.activeElement);
      if (e.key === "Escape") {
        e.preventDefault();
        close(true);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        var next = vis[idx + 1] || vis[0];
        if (next) next.focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        var prev = vis[idx - 1] || vis[vis.length - 1];
        if (prev) prev.focus();
      }
    }

    trigger.addEventListener("click", function () {
      if (isOpen()) { close(false); } else { open(); }
    });
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        open();
      }
    });
    root.addEventListener("click", function (e) {
      var item = e.target.closest("[data-input-dropdown-item]");
      if (item && root.contains(item)) selectItem(item);
    });
    if (search) search.addEventListener("input", filter);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-field"] && !Shopify.designMode) return;
  try {
    (() => {
  const FIELD = '.field.input-field';
  const INPUT = FIELD + ' .field__input';

  const isControl = (el) => (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) && el.matches(INPUT);

  const messageFor = (input) => {
    if (input.validity.valueMissing) return input.dataset.errorRequired;
    return input.dataset.errorInvalid || input.validationMessage;
  };

  const setError = (input, text) => {
    const field = input.closest(FIELD);
    if (!field) return;
    field.classList.add('input-field--error');
    input.setAttribute('aria-invalid', 'true');
    let msg = field.querySelector('.input-field__message--error[data-client]');
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'input-field__message input-field__message--error';
      msg.setAttribute('role', 'alert');
      msg.dataset.client = '';
      msg.id = input.id + '-message';
      input.setAttribute('aria-describedby', msg.id);
      const label = input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : input;
      label.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = '';
    const star = document.createElement('span');
    star.setAttribute('aria-hidden', 'true');
    star.textContent = '*';
    msg.append(star, text || '');
  };

  const clearError = (input) => {
    const field = input.closest(FIELD);
    if (!field || !field.classList.contains('input-field--error')) return;
    const msg = field.querySelector('.input-field__message--error[data-client]');
    // Only client-set errors are cleared; a server-rendered error stays until resubmit.
    if (!msg) return;
    msg.remove();
    field.classList.remove('input-field--error');
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
  };

  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!isControl(input)) return;
    event.preventDefault(); // no native bubble - the Figma Error state carries the message
    setError(input, messageFor(input));
    // The first invalid control in a submit takes focus (the bubble used to do this).
    const form = input.form;
    if (form) {
      const firstInvalid = [...form.querySelectorAll(INPUT)].find((el) => !el.validity.valid);
      if (firstInvalid === input) input.focus();
    }
  }, true);

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!isControl(input)) return;
    if (input.validity.valid) clearError(input);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-search"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll("[data-input-search]").forEach(function (form) {
    var input = form.querySelector("input[type=search]");
    var clear = form.querySelector("[data-input-search-clear]");
    if (!input) return;

    function sync() {
      form.classList.toggle("input-search--has-value", input.value.length > 0);
    }

    input.addEventListener("input", sync);
    sync();

    if (clear) {
      clear.addEventListener("click", function () {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.focus();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-textarea"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (e) {
  var el = e.target;
  if (!el || !el.hasAttribute || !el.hasAttribute('data-textarea-count')) return;
  var meta = el.closest('.input-textarea');
  if (!meta) return;
  var counter = meta.querySelector('[data-textarea-count-current]');
  if (counter) counter.textContent = String(el.value.length);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-colour-swatches"] && !Shopify.designMode) return;
  try {
    // Hover previews the hovered colourway's name in the label (Figma hover state).
  // Delegated once at document level; survives Section Rendering swaps.
  if (!window.__pdpColourHoverBound) {
    window.__pdpColourHoverBound = true;
    document.addEventListener("mouseover", (event) => {
      const swatch = event.target.closest("[data-swatch-colour]");
      if (!swatch) return;
      const label = swatch.closest("[data-pdp-colour]")?.querySelector("[data-colour-current]");
      if (!label) return;
      if (!label.dataset.original) label.dataset.original = label.textContent;
      label.textContent = swatch.dataset.swatchColour.toLowerCase();
    });
    document.addEventListener("mouseout", (event) => {
      const swatch = event.target.closest("[data-swatch-colour]");
      if (!swatch) return;
      const label = swatch.closest("[data-pdp-colour]")?.querySelector("[data-colour-current]");
      if (label && label.dataset.original) label.textContent = label.dataset.original;
    });
  }

  // Productive #354 - fills the deferred tiles (siblings past the Liquid's
  // all_products budget) from each sibling's product JSON, under the same rules as
  // the server-rendered tiles. Requests are shared, so the details-column and
  // sticky-bar instances fetch each sibling once.
  if (!customElements.get("pdp-colour-swatches")) {
    const siblingRequests = new Map();

    const fetchSibling = (url) => {
      if (!siblingRequests.has(url)) {
        siblingRequests.set(
          url,
          fetch(url, { headers: { Accept: "application/json" } })
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        );
      }
      return siblingRequests.get(url);
    };

    const fileName = (src) => src.split("/").pop().split("?")[0].toLowerCase();

    const sizedUrl = (src, size) => {
      const url = new URL(src, window.location.origin);
      url.searchParams.set("width", size);
      url.searchParams.set("height", size);
      url.searchParams.set("crop", "center");
      return url.toString();
    };

    // The Liquid's "-1" product-shot rule, else the featured image.
    const swatchImageFor = (product) =>
      (product.images ?? []).find((src) => fileName(src).includes("-1.")) ?? product.featured_image;

    // The Liquid's fallback for a sibling with no metafield colourName: its
    // `colour|` tag, else the title's last "-" segment.
    const colourFromProduct = (product) => {
      const tag = (product.tags ?? []).find((t) => t.slice(0, 7) === "colour|");
      if (tag) return tag.split("colour|").join("").replace(/-/g, " ");
      return product.title.split("-").pop().trim();
    };

    // Same tile as the Liquid's image_tag: 165px centre crop, 55 / 110 / 165 candidates.
    const createSwatchImage = (src, alt) => {
      const img = document.createElement("img");
      img.src = sizedUrl(src, 165);
      img.srcset = [55, 110, 165].map((size) => `${sizedUrl(src, size)} ${size}w`).join(", ");
      img.sizes = "55px";
      img.width = 55;
      img.height = 55;
      img.loading = "lazy";
      img.alt = alt;
      return img;
    };

    class PdpColourSwatches extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll("[data-swatch-deferred]").forEach((swatch) => {
          // Cleared up front so a reconnect never fills the same tile twice.
          swatch.removeAttribute("data-swatch-deferred");
          this.hydrate(swatch);
        });
      }

      async hydrate(swatch) {
        const product = await fetchSibling(`${swatch.getAttribute("href")}.js`);
        if (!product?.available || !product.featured_image) {
          swatch.remove();
          return;
        }
        let colour = swatch.dataset.swatchColour;
        if (!colour) {
          colour = colourFromProduct(product);
          const colourLabel = window.__pdpColourSwatchesStrings?.colourLabel ?? "";
          swatch.dataset.swatchColour = colour;
          swatch.title = colour;
          swatch.setAttribute("aria-label", `${colourLabel} ${colour}`.trim());
        }
        swatch.append(createSwatchImage(swatchImageFor(product), colour));
      }
    }

    customElements.define("pdp-colour-swatches", PdpColourSwatches);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-shot-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("plp-shot-toggle")) {
    class PlpShotToggle extends HTMLElement {
      connectedCallback() {
        if (this.__bound) return;
        this.__bound = true;
        this.input = this.querySelector('input[type="checkbox"]');
        if (!this.input) return;
        // The toggle lives inside FacetFiltersForm - keep its input/change events
        // from bubbling into facets.js's debounced form listener (it would fire a
        // pointless filter re-query on every flip).
        this.addEventListener("input", (e) => e.stopPropagation());
        this.addEventListener("change", (e) => e.stopPropagation());
        // Restore the per-session preference (default: product shots = off, QA #217).
        var stored = null;
        try {
          stored = window.sessionStorage.getItem("plp-shot");
        } catch (e) {
          /* storage unavailable - fall through to default */
        }
        if (stored === "product") {
          this.input.checked = false;
        } else if (stored === "model") {
          this.input.checked = true;
        }
        this.apply();
        this.input.addEventListener("change", () => {
          this.apply();
          try {
            window.sessionStorage.setItem("plp-shot", this.input.checked ? "model" : "product");
          } catch (e) {
            /* non-fatal */
          }
        });
        // Re-apply when facets.js swaps the grid HTML (Section Rendering API) and
        // once on load after the card swipers initialise.
        var grid = document.getElementById("ProductGridContainer");
        if (grid && !grid.__shotObserver) {
          grid.__shotObserver = new MutationObserver(() => {
            window.requestAnimationFrame(() => this.apply());
          });
          grid.__shotObserver.observe(grid, { childList: true, subtree: false });
        }
        window.addEventListener("load", () => this.apply(), { once: true });
        // Productive #258 - Load More appends cards INSIDE .load-more-grid, below
        // the grid observer's childList scope, and their swipers are built at
        // append time, so a Model-on shopper saw page 2 arrive on the packshot
        // slide. load-more.js announces the append; re-apply after the swipers
        // have settled.
        if (!this.__appendBound) {
          this.__appendBound = true;
          document.addEventListener("plp:products-appended", () => {
            window.requestAnimationFrame(() => this.apply());
          });
        }
      }

      disconnectedCallback() {
        this.__bound = false;
      }

      apply() {
        var model = this.input.checked;
        document.body.classList.toggle("plp-shot--model", model);
        this.applyToSliders(model);
      }

      // Slider-idiom cards (settings.on_hover == 'slider'): drive each card's
      // swiper to slide 2 (media[1], the model shot) when Model is on, and back
      // to slide 1 (the packshot) when it is off. Re-applied on facets.js
      // Section Rendering re-renders via the grid observer below.
      applyToSliders(model) {
        document.querySelectorAll(".collection-product-card .swiper").forEach(function (el) {
          if (el.swiper) el.swiper.slideTo(model ? 1 : 0, 0);
        });
      }
    }
    customElements.define("plp-shot-toggle", PlpShotToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
